import {Injectable} from '@angular/core';
import {ImageDetail} from "../types/groups/types";

@Injectable({
    providedIn: 'root'
})
export class GroupImageSjcUpdatedDialogControllerService {
    dialogVisible = false;
    private updatingImage: ImageDetail | undefined;

    setDialogVisible(visible: boolean) {
        this.dialogVisible = visible;
    }

    setUpdatingImage(image: ImageDetail) {
        this.updatingImage = image
    }

    getSjcGroupImage() {
        return this.updatingImage;
    }
}
